function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';
import Image from '../Image';
import StarRating from '../StarRating';
import Player from '../Player';
import Icon from '../Icon';
import Button from '../Button';
var defaultPlayerInfoClassnames = classNames('psw-l-w-3/4', 'psw-l-w-1/4@tablet-s', 'psw-l-w-1/4@tablet-l', 'psw-l-w-1/4@laptop', 'psw-l-w-1/4@desktop', 'psw-l-w-1/4@max', 'psw-l-align-top');
var defaultReviewInfoClassnames = classNames('psw-l-w-3/4', 'psw-l-w-1/2@tablet-s', 'psw-l-w-1/2@tablet-l', 'psw-l-w-1/2@laptop', 'psw-l-w-1/2@desktop', 'psw-l-w-1/2@max');
var spacerClassnames = classNames('psw-l-exclude@laptop-and-above', 'psw-l-exclude@tablet-l', 'psw-l-exclude@tablet-s', 'psw-p-l-5');
/**
 *
 * TextReviewTile component displays user text reviews. The component contains all
 * the user related information along with the review details. The tile is responsive as
 * such that the text body truncates after 3 lines in desktop mode and presents Read More
 * option in truncated more.
 *
 * ## Composed of
 * - [Player](./Player/README.md)
 * - [Button](./Button/README.md)
 * - [Image](./Image/README.md)
 * ## Usage
 *
 * ```jsx
 * <TextReviewTile
      reviewText={reviewTextNonOverflow}
      reviewTitle="Review Title"
      productEdition="Deluxe Edition"
      reviewerName="Scorpion 1234"
      starRating={3}
      reviewerHasPsPlus
      reviewerPictureLink=""
      ratingDate="Rated 08/15/2023"
      showSpoilerText="Show Spoilers"
      reportText="Report"
      helpfulText="Helpful"
      qa="text-review-tile"
    />
 *
 * ```
 */

var TextReviewTile = function TextReviewTile(_ref) {
  var qa = _ref.qa,
      containsSpoiler = _ref.containsSpoiler,
      reviewText = _ref.reviewText,
      reviewTitle = _ref.reviewTitle,
      reviewerHasPsPlus = _ref.reviewerHasPsPlus,
      productEdition = _ref.productEdition,
      reviewerName = _ref.reviewerName,
      starRating = _ref.starRating,
      ratingDate = _ref.ratingDate,
      reviewerPictureLink = _ref.reviewerPictureLink,
      showSpoilerText = _ref.showSpoilerText,
      onClickHelpful = _ref.onClickHelpful,
      onClickReport = _ref.onClickReport,
      helpfulText = _ref.helpfulText,
      reportText = _ref.reportText,
      readLessText = _ref.readLessText,
      readMoreText = _ref.readMoreText,
      playerInfoClassnames = _ref.playerInfoClassnames,
      reviewInfoClassnames = _ref.reviewInfoClassnames,
      telemetryMetaHelpfulCta = _ref.telemetryMetaHelpfulCta,
      telemetryMetaReportCta = _ref.telemetryMetaReportCta,
      telemetryMetaShowSpoilerCta = _ref.telemetryMetaShowSpoilerCta,
      trackClickHelpfulCta = _ref.trackClickHelpfulCta,
      trackClickReportCta = _ref.trackClickReportCta,
      trackClickShowSpoilerCta = _ref.trackClickShowSpoilerCta,
      isReviewReported = _ref.isReviewReported,
      isReviewMarkedHelpful = _ref.isReviewMarkedHelpful,
      errorMsg = _ref.errorMsg;

  var _useState = useState(!containsSpoiler),
      _useState2 = _slicedToArray(_useState, 2),
      displaySpoilerText = _useState2[0],
      setDisplaySpoilerText = _useState2[1];

  var textRef = useRef(null);

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOverflow = _useState4[0],
      setIsOverflow = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isExpanded = _useState6[0],
      setIsExpanded = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      helpfulCtaHasError = _useState8[0],
      setHelpfulCtaHasError = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      reportCtaHasError = _useState10[0],
      setReportCtaHasError = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      requestPending = _useState12[0],
      setRequestPending = _useState12[1];

  useEffect(function () {
    if (helpfulCtaHasError) {
      setTimeout(function () {
        return setHelpfulCtaHasError(false);
      }, 2500);
    }
  }, [helpfulCtaHasError]);
  useEffect(function () {
    if (reportCtaHasError) {
      setTimeout(function () {
        return setReportCtaHasError(false);
      }, 2500);
    }
  }, [reportCtaHasError]);
  var setDisplaySpoilerTextCallback = useCallback(function () {
    setDisplaySpoilerText(true);
  }, []);
  var onClickReportWrapper = useCallback(function () {
    if (onClickReport) {
      onClickReport().then(function () {
        return setReportCtaHasError(false);
      }).catch(function () {
        return setReportCtaHasError(true);
      });
    }
  }, [onClickReport]);
  var onClickHelpfulWrapper = useCallback(function () {
    if (onClickHelpful && !requestPending) {
      setRequestPending(true);
      onClickHelpful().then(function () {
        return setHelpfulCtaHasError(false);
      }).catch(function () {
        return setHelpfulCtaHasError(true);
      }).finally(function () {
        return setRequestPending(false);
      });
    }
  }, [onClickHelpful, requestPending]);
  var setIsExpandedCallback = useCallback(function () {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);
  useEffect(function () {
    var resizeObserver = new ResizeObserver(function () {
      if (textRef === null || textRef === void 0 ? void 0 : textRef.current) {
        var _textRef$current, _textRef$current2;

        var overflow = (textRef === null || textRef === void 0 ? void 0 : (_textRef$current = textRef.current) === null || _textRef$current === void 0 ? void 0 : _textRef$current.scrollHeight) > (textRef === null || textRef === void 0 ? void 0 : (_textRef$current2 = textRef.current) === null || _textRef$current2 === void 0 ? void 0 : _textRef$current2.clientHeight);
        setIsOverflow(overflow);
      }
    });

    if (textRef === null || textRef === void 0 ? void 0 : textRef.current) {
      resizeObserver.observe(textRef.current);
    }

    return function () {
      resizeObserver.disconnect();
    };
  }, [reviewText, textRef === null || textRef === void 0 ? void 0 : textRef.current]); // does not contain spoilers
  // or if spoiler is there then it review text is displays

  var isReviewCtasActive = !containsSpoiler || containsSpoiler && displaySpoilerText;

  var onReviewCtaClicked = function onReviewCtaClicked(callback) {
    return function () {
      if (isReviewCtasActive) {
        callback();
      }
    };
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames('psw-l-grid', 'psw-l-line-center', 'psw-l-align-top', 'psw-text-review-tile')
  }, /*#__PURE__*/React.createElement("div", {
    className: playerInfoClassnames
  }, /*#__PURE__*/React.createElement("div", {
    className: "psw-l-line-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: spacerClassnames
  }), /*#__PURE__*/React.createElement(Player, {
    qa: "".concat(qa, "#reviewer"),
    isPsPlusMember: reviewerHasPsPlus,
    trophyLevel: false,
    name: reviewerName,
    image: /*#__PURE__*/React.createElement(Image, {
      className: classNames('psw-text-review-player-image', 'psw-r-pill'),
      alt: "",
      src: reviewerPictureLink
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: spacerClassnames
  }))), /*#__PURE__*/React.createElement("div", {
    className: reviewInfoClassnames
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('psw-l-line-left', 'psw-text-review-labels')
  }, /*#__PURE__*/React.createElement("div", {
    className: spacerClassnames
  }), /*#__PURE__*/React.createElement(StarRating, {
    readOnly: true,
    starSize: "2",
    value: starRating,
    qa: "".concat(qa, "#rating")
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames('psw-m-l-4', 'psw-t-secondary'),
    "data-qa": "".concat(qa, "#ratings-date")
  }, ratingDate), /*#__PURE__*/React.createElement("div", {
    className: spacerClassnames
  })), /*#__PURE__*/React.createElement("div", null, productEdition && /*#__PURE__*/React.createElement("div", {
    className: "psw-l-line-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: spacerClassnames
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames('psw-t-tag', 'psw-p-2', 'psw-text-review-labels')
  }, productEdition), /*#__PURE__*/React.createElement("div", {
    className: spacerClassnames
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames('psw-l-anchor')
  }, /*#__PURE__*/React.createElement("div", {
    className: "psw-l-line-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: spacerClassnames
  }), /*#__PURE__*/React.createElement(React.Fragment, null, !displaySpoilerText && /*#__PURE__*/React.createElement("div", {
    className: classNames('psw-l-layer', 'psw-l-line-center', 'psw-l-z-1')
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: setDisplaySpoilerTextCallback,
    variant: "content",
    className: classNames('psw-ally-indicator', 'psw-l-line-center'),
    qa: "".concat(qa, "#spoiler"),
    trackClick: trackClickShowSpoilerCta,
    telemetryMeta: telemetryMetaShowSpoilerCta
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "hidden",
    size: "xl",
    qa: "".concat(qa, "#spoiler-icon")
  }), /*#__PURE__*/React.createElement("span", {
    className: "psw-t-title-m",
    "data-qa": "".concat(qa, "#spoiler-text")
  }, showSpoilerText))), /*#__PURE__*/React.createElement("div", {
    className: classNames(!displaySpoilerText && 'psw-spoiler-text'),
    "data-qa": "".concat(qa, "#review")
  }, /*#__PURE__*/React.createElement("div", {
    className: "psw-t-button",
    "data-qa": "".concat(qa, "#review-title")
  }, reviewTitle), /*#__PURE__*/React.createElement("p", {
    className: classNames('psw-m-t-4', !isExpanded && 'psw-review-text'),
    ref: textRef,
    "data-qa": "".concat(qa, "#review-body")
  }, reviewText), (isOverflow || isExpanded) && /*#__PURE__*/React.createElement(Button, {
    className: classNames('psw-ally-indicator', 'psw-t-button', 'psw-text-review-read-more-less'),
    variant: "content",
    onClick: setIsExpandedCallback,
    qa: "".concat(qa, "#button#").concat(isExpanded ? 'readless' : 'readmore')
  }, isExpanded ? readLessText : readMoreText))), /*#__PURE__*/React.createElement("div", {
    className: spacerClassnames
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames('psw-l-line-repel', 'psw-text-review-ctas')
  }, /*#__PURE__*/React.createElement("div", {
    className: "psw-text-review-helpful psw-l-line-left psw-l-h-7"
  }, /*#__PURE__*/React.createElement("div", {
    className: spacerClassnames
  }), helpfulCtaHasError ? /*#__PURE__*/React.createElement("span", {
    className: classNames('psw-l-line-left', 'psw-l-align-center')
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "3",
    type: "error-message-caution"
  }), errorMsg) : /*#__PURE__*/React.createElement("div", {
    className: classNames('psw-l-line-left', 'psw-l-align-center')
  }, /*#__PURE__*/React.createElement(Button, {
    ctaType: "primary",
    className: classNames('psw-t-size-2', {
      'psw-is-disabled': isReviewMarkedHelpful || !isReviewCtasActive
    }),
    size: "small",
    onClick: !isReviewMarkedHelpful ? onReviewCtaClicked(onClickHelpfulWrapper) : function () {},
    qa: "".concat(qa, "#button#helpful"),
    ariaDisabled: isReviewMarkedHelpful || !isReviewCtasActive,
    trackClick: !isReviewMarkedHelpful || !isReviewCtasActive ? trackClickHelpfulCta : null,
    telemetryMeta: !isReviewMarkedHelpful || !isReviewCtasActive ? telemetryMetaHelpfulCta : null
  }, /*#__PURE__*/React.createElement("div", {
    className: "psw-l-line-left psw-l-align-center"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "good",
    size: "s",
    qa: "".concat(qa, "#helpful")
  }), /*#__PURE__*/React.createElement("div", null, helpfulText))))), /*#__PURE__*/React.createElement("div", {
    className: "psw-text-review-report psw-l-line-left psw-l-h-7"
  }, reportCtaHasError ? /*#__PURE__*/React.createElement("span", {
    className: classNames('psw-l-line-left', 'psw-l-align-center')
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "3",
    type: "error-message-caution"
  }), errorMsg) : /*#__PURE__*/React.createElement("div", {
    className: classNames('psw-l-line-left', 'psw-l-align-center')
  }, /*#__PURE__*/React.createElement(Button, {
    ctaType: "primary",
    size: "small",
    className: classNames('psw-t-size-2', {
      'psw-is-disabled': isReviewReported || !isReviewCtasActive
    }),
    onClick: !isReviewReported ? onReviewCtaClicked(onClickReportWrapper) : function () {},
    qa: "".concat(qa, "#button#report"),
    ariaDisabled: isReviewReported || !isReviewCtasActive,
    trackClick: !isReviewReported || !isReviewCtasActive ? trackClickReportCta : null,
    telemetryMeta: !isReviewReported || !isReviewCtasActive ? telemetryMetaReportCta : null
  }, /*#__PURE__*/React.createElement("div", {
    className: "psw-l-line-left psw-l-align-center"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "flag",
    size: "s",
    qa: "".concat(qa, "#report-flag")
  }), /*#__PURE__*/React.createElement("div", null, reportText)))), /*#__PURE__*/React.createElement("div", {
    className: spacerClassnames
  })))));
};

TextReviewTile.defaultProps = {
  containsSpoiler: false,
  reviewTitle: '',
  reviewText: '',
  reviewerHasPsPlus: false,
  productEdition: '',
  reviewerName: '',
  starRating: 0,
  reviewerPictureLink: '',
  ratingDate: '',
  showSpoilerText: '',
  onClickHelpful: function onClickHelpful() {},
  onClickReport: function onClickReport() {},
  helpfulText: '',
  reportText: '',
  readMoreText: 'Read More',
  readLessText: 'Read Less',
  playerInfoClassnames: defaultPlayerInfoClassnames,
  reviewInfoClassnames: defaultReviewInfoClassnames,
  qa: '',
  telemetryMetaHelpfulCta: null,
  telemetryMetaReportCta: null,
  telemetryMetaShowSpoilerCta: null,
  trackClickHelpfulCta: null,
  trackClickReportCta: null,
  trackClickShowSpoilerCta: null,
  isReviewReported: false,
  isReviewMarkedHelpful: false,
  errorMsg: 'Something went wrong. Try again later.'
};
TextReviewTile.propTypes = {
  /**
   * Whether spoilers are contained in the review. Text review containing spoiler
   * will be blurred and option will be presented to unblur it.
   */
  containsSpoiler: PropTypes.bool,

  /**
   * The title text for the review
   */
  reviewTitle: PropTypes.string,

  /**
   * Review of the text
   */
  reviewText: PropTypes.string,

  /**
   * Whether the reviewer has PS plus subscription
   */
  reviewerHasPsPlus: PropTypes.bool,

  /**
   * Product edition that name belong to
   */
  productEdition: PropTypes.string,

  /**
   * Reviewer profile name
   */
  reviewerName: PropTypes.string,

  /**
   * Number of stars rated by the reviewer
   */
  starRating: PropTypes.number,

  /**
   * Profile picture link
   */
  reviewerPictureLink: PropTypes.string,

  /**
   * Date the ratings was performed
   */
  ratingDate: PropTypes.string,

  /**
   * Show Spoiler Text
   */
  showSpoilerText: PropTypes.string,

  /**
   * event callback when user clicks on Helpful button. Must return a Promise
   */
  onClickHelpful: PropTypes.func,

  /**
   * event callback when user clicks on Report button. Must return a Promise
   */
  onClickReport: PropTypes.func,

  /**
   * Helpful option text
   */
  helpfulText: PropTypes.string,

  /**
   * Report option text
   */
  reportText: PropTypes.string,

  /**
   * Read more text
   */
  readMoreText: PropTypes.string,

  /**
   * Read less text
   */
  readLessText: PropTypes.string,

  /**
   * Styles to be applied to the section displaying reviewer's name, photo, etc.
   */
  playerInfoClassnames: PropTypes.string,

  /**
   * Styles to be applied to the section displaying review text, rating, etc.
   */
  reviewInfoClassnames: PropTypes.string,

  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
  * Serialized json data of context specific telemetry data for helpful CTA
  */
  telemetryMetaHelpfulCta: PropTypes.string,

  /**
  * Serialized json data of context specific telemetry data for report CTA
  */
  telemetryMetaReportCta: PropTypes.string,

  /**
  * Serialized json data of context specific telemetry data for show spoiler CTA
  */
  telemetryMetaShowSpoilerCta: PropTypes.string,

  /**
   * The spec id identifying the interaction for helpful CTA
   */
  trackClickHelpfulCta: PropTypes.string,

  /**
   * The spec id identifying the interaction for report CTA
   */
  trackClickReportCta: PropTypes.string,

  /**
   * The spec id identifying the interaction for show spoiler CTA
   */
  trackClickShowSpoilerCta: PropTypes.string,

  /**
   * mark review as report to disable further actions
   */
  isReviewReported: PropTypes.bool,

  /**
   * Disables helpful cta if review has already been marked as helpful
   */
  isReviewMarkedHelpful: PropTypes.bool,

  /**
   * Error message to be shown in case of error in voting helpful or reporting review
   */
  errorMsg: PropTypes.string
};
export default TextReviewTile;